// Legacy code, just modularized
// Free text service search (404 page)

import $ from 'jquery';
import Mustache from 'mustache';

var serviceSearch = (function() {
  var app = {};

  // Autocomplete search terms. Suggestive search input on services page.
  app.autocomplete = (function() {
    var namesSynonyms = null;
    var loading = false;

    // Filter results. Match name or synonyms to input.
    var filter = function(val) {

      var itemCount = 0;
      // Contruct array with matching names or synonyms
      var results = $.grep(namesSynonyms, function(item, i) {
        item.name_matches = false;

        var filterName = item.name.indexOf(val) > -1; // true or false per item
        var filterSynonym = false; // synonyms are not required and they can be multiple per item
        item.synonym_result = [];
        if(item.synonym) { // not a required field
          var synonymsMatched = 0; // find all matching ones
          for(i = 0; i < item.synonym.length; i++) {
            if(item.synonym[i].indexOf(val) > -1) {
              synonymsMatched++;
              itemCount++;
              item.synonym_result.push({
                synonym: item.synonym[i]
              });
            }
          }
          // one or more synonyms match -> the item is a match
          if(synonymsMatched > 0) {
            filterSynonym = true;
          }

        }
        if(filterName === true) {
          item.name_matches = true;
          itemCount++;
        }
        // return item if name or synonym or both are true
        return (filterSynonym || filterName);
      });

      // Show matches in markup
      var numberOfMatches = itemCount;

      $('#service-autocomplete-results').show();

      var template = $('#mustache-autocomplete').html();

      $('#service-autocomplete-results').html(
        Mustache.render(template, results)
      );

      if(itemCount === 0) {
        var noresultsHtml = '<div class="autocomplete-match" tabindex="0"><span>Ei hakutuloksia hakusanalle <i>' + $('#service-search').val() + '</i>.</span></div>';
        $('#service-autocomplete-results').html(noresultsHtml);
      }

      if(numberOfMatches === 0) {
        $.ajax({
          type: 'POST',
          url: '/stage-ajax/logServiceSearchTerms?stage-language=fi', //TODO get language from Stage
          data: { userinput: val },
          success: function(resp) {
          }
        });
      }

    };

    // init
    var init = function() {
      // Listen to typing letters on search submit
      $('#service-search-form').on('submit', function(e) {
        e.preventDefault();
        var input = $('#service-search');
        if(input.val().length > 1) { // start matching only after typed 2 letters
          if(!loading) { // wait for ajax
            if(!namesSynonyms) { // only query results once from db
              loading = true;
              $.ajax({
                url: '/stage-ajax/getServiceNamesSynonyms?stage-language=fi',//TODO get language from Stage
                success: function(resp) {
                  namesSynonyms = resp; // returns array
                  filter($(input).val().toLowerCase());
                  loading = false;
                }
              });
            } else {
              filter($(input).val().toLowerCase());
            }
          }
        }
        if(input.val().length === 0) {
          $('#service-autocomplete-results').hide();
          $('.autocomplete-match').remove();
        }
      });
    };

    return {
      init: init
    };

  })(); // end autocomplete

  // Search searchterm from the whole services database, return URLs containing search term.
  // Log search terms that have no matches
  app.search = (function() {
    var init = function() {
    };

    return {
      init: init
    };
  })(); // end search for term

  app.init = function() {
    app.autocomplete.init();
    //app.search.init();
  };

  return app;
})(); // end services module

export default serviceSearch;
